import React from 'react';
import classNames from 'classnames';
import { useNavHeight } from './useNavHeight';

import './StickUnderNav.scss';

type Props = React.HTMLAttributes<HTMLDivElement>;

export const StickUnderNav: React.FC<Props> = ({ className, children, ...rest }) => {
  const { height } = useNavHeight();

  const top = height ? height - 1 : 0;

  return (
    <div className={classNames('StickUnderNav', className)} {...rest} style={{ top }}>
      {children}
    </div>
  );
};
